import _ from '@rover/globals/underscore';
import Rover from '@rover/globals/Rover';

import StaticStickitView from './static_stickit_view';

export default StaticStickitView.extend({
  // A view for selecting the minimum and maximum price.  The view
  // takes a Query as its model and its input boxes are bound its
  // 'minprice' and 'maxprice' attributes.

  bindings: {
    '.heading': {
      observe: 'service_type',
      update($el, val) {
        const serviceType = _.findWhere(Rover.serviceTypesJson, { slug: val });

        if (serviceType) {
          $el.text(`Rate per ${serviceType.price_units}?`);
        }
      },
    },
  },

  initialize(options) {
    const self = this;

    this.searchResults = options.searchResults;
    // Update the view when the model changes
    this.listenTo(this.searchResults, 'change', _.bind(this.onSearchResultsChanged, this));

    this.createPriceObjects();

    const sliderOptions = {
      min: 10,
      max: 150,
      step: 1,
      value: [this.getMin(), this.getMax()],
    };

    const $priceSliderEl = this.$('.js-price-slider');

    if (!$priceSliderEl.length) {
      return;
    }

    // Create the slider
    this.slider = $priceSliderEl.slider(sliderOptions);

    // Set inital UI values
    this.setValues();

    // Update the input fields on slide, trigger change on stop
    this.slider.on('slideStop', _.bind(this.onSlideStop, this));

    this.slider.on('slide', _.bind(this.onSlide, this));

    // Update the slider on model changes
    this.model.on('change:minprice change:maxprice', _.bind(this.updateSlider, this));

    this.model.on('change:service_type', () => {
      self.updateSlider();
      self.setValues();
    });

    StaticStickitView.prototype.initialize.call(this);
  },

  onSearchResultsChanged() {
    this.setValues();
  },

  createPriceObjects() {
    const service = this.model.get('service_type');
    let oldMinPrice = this.model.get('minprice');
    let oldMaxPrice = this.model.get('maxprice');

    if (typeof oldMinPrice === 'object') {
      oldMinPrice = oldMinPrice[service];
    }

    if (typeof oldMaxPrice === 'object') {
      oldMaxPrice = oldMaxPrice[service];
    }

    this.model.set('minprice', {
      'overnight-boarding': 10,
      'overnight-traveling': 10,
      'drop-in': 10,
      'doggy-day-care': 10,
      'dog-walking': 10,
    });

    this.model.set('maxprice', {
      'overnight-boarding': 150,
      'overnight-traveling': 150,
      'drop-in': 150,
      'doggy-day-care': 150,
      'dog-walking': 150,
    });

    // Carry over prices that came through the URL
    if (oldMinPrice !== null) {
      this.model.get('minprice')[service] = oldMinPrice;
    }

    if (oldMaxPrice !== null) {
      this.model.get('maxprice')[service] = oldMaxPrice;
    }
  },

  getMin() {
    const service = this.model.get('service_type') || 'overnight-boarding';

    // Returns the minimum price from the model as an int
    return parseInt(this.model.get('minprice')[service], 10);
  },

  getMax() {
    const service = this.model.get('service_type') || 'overnight-boarding';

    // Returns the maximum price from the model as an int
    return parseInt(this.model.get('maxprice')[service], 10);
  },

  setValues() {
    const service = this.model.get('service_type') || 'overnight-boarding';
    const prices = this.$('.js-price-slider').slider('getValue');
    const [min, max] = prices;
    const currencySymbol = this.searchResults.safeGet('derived_data.currency_symbol', '$');

    this.model.get('minprice')[service] = min;
    this.$('.js-search-minprice').val(min);
    this.$('.js-search-minprice-label').text(`${currencySymbol}${min}`);

    this.model.get('maxprice')[service] = max;
    this.$('.js-search-maxprice').val(max);
    this.$('.js-search-maxprice-label').text(`${currencySymbol}${max}`);
  },

  onSlide() {
    this.setValues();
  },

  onSlideStop() {
    this.setValues();
    this.model.trigger('change', this.model);
  },

  updateSlider() {
    this.createPriceObjects();

    // Updates the slider when the query object is changed
    this.slider.slider('setValue', [this.getMin(), this.getMax()]);
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/price_slider_view.js